import { createLogic, Logic } from 'redux-logic';

import { login as loginRequest, logout as logoutRequest, loginViaAD as loginViaADRequest } from 'api/auth';

import {
  actions as userActions,
  actionTypes as userActionTypes,
  IUser,
}                                                       from 'reducer/user';
import { actions as settingsActions }                   from 'reducer/settings';
import { actions as messagesActions }                   from 'reducer/messages';
import { getUserColumnsRequest, setUserColumnsRequest } from '../api/users';
import { UserColumns }                                  from '../types/system';
import { IRootState }                                   from '../reducer';
import { actions as mapActions }                        from '../reducer/map';

const loginViaAD = createLogic({
  type: userActionTypes.PERFORM_LOGIN_AD,
  latest: true,
  warnTimeout: 0,

  async process({ action }: { action: any }, dispatch, done) {
    return await loginViaADRequest({
                                login: action.payload.username,
                                password: action.payload.password,
                              })
      .then((response) => {
        console.log(response);
        dispatch(userActions.performLogin({ ...action.payload, useActiveDirectory: true }));
        done();
      })
      .catch((error) => {
        console.dir(error);
        let message: string = 'Сервер недоступен';
        if (error.response) {
          switch (error.response.status) {
            case 401:
              message = 'Неверный логин или пароль';
              break;
            case 500:
              message = 'Внутренняя проблема сервера';
              break;
          }
        }
        dispatch(
          messagesActions.addToStack({ messages: [message], key: `${Date.now()}` })
        );
        dispatch(userActions.performLoginFailure({ ...error }));
        done();
      });
  },
});

const login = createLogic({
  type: userActionTypes.PERFORM_LOGIN,
  latest: true,
  warnTimeout: 0,

  async process({ action }: { action: any }, dispatch, done) {
    return await loginRequest({
      username: action.payload.username,
      password: action.payload.password,
      useActiveDirectory: action.payload.useActiveDirectory,
    })
      .then(({ token, user }: { token: string; user: IUser }) => {
          if (user.isBlocked) {
          dispatch(userActions.performLoginFinish());
          dispatch(
            messagesActions.addToStack({
              messages: ['Пользователь заблокирован'],
              key: '',
            })
          );
        } else {
          localStorage.setItem('token', token);
          dispatch(userActions.performLoginSuccess(user));
          dispatch(settingsActions.setSettings(user.settings));
          if (user.mapSettings) {
            dispatch(mapActions.saveCurrentPosition({ settings: user.mapSettings }));
            dispatch(mapActions.changeCurrentPosition({ settings: user.mapSettings }));
          }
          done();
        }
      })
      .catch((error: any) => {
        dispatch(
          messagesActions.addToStack(
            error.response
              ? { ...error.response.data }
              : { messages: ['Сервер недоступен'] }
          )
        );
        dispatch(userActions.performLoginFailure({ ...error }));
        done();
      });
  },
});
const logout = createLogic({
  type: userActionTypes.LOG_OUT,
  latest: true,
  warnTimeout: 0,

  async process(_, dispatch) {
    logoutRequest().then(() => {
      localStorage.removeItem('token')
      dispatch(userActions.logOutSuccess());
    });
  },
});

const getUserColumns = createLogic<IRootState, { table: string }>({
  type: userActionTypes.GET_COLUMNS_VISIBILITY,
  latest: true,
  warnTimeout: 0,

  process: async ({ action }, dispatch) => {
    const { table } = action.payload;
    const { fields } = await getUserColumnsRequest(table);
    dispatch(
      userActions.getColumnsSuccess({
        columns: fields,
        table,
      })
    );
  },
});

const setUserColumns = createLogic<
  IRootState,
  {
    table: string;
    value: boolean;
    column: string;
  }
>({
  type: userActionTypes.SET_COLUMNS_VISIBILITY,
  latest: true,
  warnTimeout: 0,

  process: async ({ action, getState }, dispatch) => {
    const { columns } = getState().user;
    const { column, table, value } = action.payload;
    const requestBody: UserColumns = {
      columns: columns[table] || [],
      table: table,
    };
    if (value) {
      requestBody.columns.push(column);
    } else {
      if (requestBody.columns.length > 1) {
        const index = requestBody.columns.indexOf(column);
        requestBody.columns = [
          ...requestBody.columns.slice(0, index),
          ...requestBody.columns.slice(index + 1),
        ];
      }
    }
    await setUserColumnsRequest(requestBody);
    dispatch(userActions.getColumnsSuccess(requestBody));
  },
});

const setSeveralColumns = createLogic<
  IRootState,
  {
    table: string;
    columns: string[];
  }
>({
  type: userActionTypes.SET_SEVERAL_COLUMNS,
  warnTimeout: 0,

  process: async ({ action: { payload }}, dispatch) => {
    await setUserColumnsRequest(payload);
    dispatch(userActions.getColumnsSuccess(payload));
  },
});

export default [
  login,
  loginViaAD,
  logout,
  getUserColumns,
  setUserColumns,
  setSeveralColumns,
] as Logic[];
